import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Expertise from './components/Expertise';
import GlobalPresence from './components/GlobalPresence';
import Innovation from './components/Innovation';
import Insights from './components/Insights';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import {
  AboutPage,
  CareersPage,
  ContactPage,
  DiversityPage,
  InsightArticlePage,
  InsightsPage,
  LegalPage,
  LocationDetailPage,
  LocationsPage,
  NotFoundPage,
  PracticeAreaDetailPage,
  PracticeAreasPage,
  ResourcePage,
  SearchPage,
  SectorDetailPage,
  SectorsPage
} from './pages/SitePages';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

const Home = () => (
  <>
    <Hero />
    <Services />
    <Expertise />
    <GlobalPresence />
    <Innovation />
    <Insights />
  </>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<PracticeAreasPage />} />
          <Route path="/services/:slug" element={<PracticeAreaDetailPage />} />
          <Route path="/sectors" element={<SectorsPage />} />
          <Route path="/sectors/:slug" element={<SectorDetailPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<InsightArticlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/locations/:slug" element={<LocationDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/diversity-inclusion" element={<DiversityPage />} />
          <Route path="/publications" element={<ResourcePage type="publications" />} />
          <Route path="/events" element={<ResourcePage type="events" />} />
          <Route path="/news" element={<ResourcePage type="news" />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/cookies" element={<LegalPage type="cookies" />} />
          <Route path="/accessibility" element={<LegalPage type="accessibility" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
